// src/utils/timeOfDayChartUtils.js

/**
 * Build the Chart.js `data` object for Discount Amount by Time of Day (Hourly).
 *
 * @param {number[]} discountAmountsPerHour - Array of 24 numbers representing discount amounts for each hour slot.
 * @param {number} [startHour=5] - The starting hour (0-23) corresponding to index 0 in the array.
 * @returns {{ labels: string[], datasets: Array }}
 */
export function getTimeOfDayDiscountChartData(
  discountAmountsPerHour,
  startHour = 5
) {
  const labels = Array.from({ length: 24 }, (_, i) => {
    const hour = (startHour + i) % 24;
    return `${hour}:00`;
  });

  return {
    labels,
    datasets: [
      {
        label: "Discount Amount",
        data: discountAmountsPerHour,
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
        fill: true,
      },
    ],
  };
}

/**
 * Build the Chart.js `options` object for a stacked hourly discount chart.
 *
 * @returns {object}
 */
export function getTimeOfDayDiscountChartOptions() {
  return {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: "Total Transactions vs Time of Day (Hours)",
      },
    },
    scales: {
      x: { stacked: true },
      y: { stacked: true },
    },
  };
}
